var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isAddingMoreData && !_vm.isLoadingResourceList
    ? _c("div", [
        _c("div", { staticClass: "go-list-end" }, [
          _c("p", [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.isSmartBriefing
                    ? _vm.$t("goListEnd.text1SmartBriefing")
                    : _vm.$t("goListEnd.text1SmartFeed")
                )
            ),
            _c("br"),
            _vm._v("\n      " + _vm._s(_vm.$t("goListEnd.text2")) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-btn-area" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.goToTop.apply(null, arguments)
                  },
                },
              },
              [
                _c("em", { staticClass: "go-text" }, [
                  _vm._v(_vm._s(_vm.$t("goListEnd.buttonText"))),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "go-icon-18 go-icon-arrow-up" }),
              ]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }